module.exports = __webpack_public_path__ + "static/img/img_solution_13.0ed241a.png";


//////////////////
// WEBPACK FOOTER
// ./static/pc/解决方案/img_solution_13.png
// module id = 0lSz
// module chunks = 0